import type {IssueStatusSearchOptions} from '@github-ui/shared-filter-providers/providers/issue-status'
import {createContext, type ReactNode, use} from 'react'

const SavedViewIssueStatusContext = createContext<IssueStatusSearchOptions | undefined>(undefined)

/**
 * Supplies the issue statuses and categories that saved view filters suggest for `status:` and
 * `category:`. Without a provider, or with an empty catalog, filters suggest CI statuses only.
 */
export function SavedViewIssueStatusProvider({
  issueStatusSearchOptions,
  children,
}: {
  issueStatusSearchOptions: IssueStatusSearchOptions | undefined
  children: ReactNode
}) {
  return <SavedViewIssueStatusContext value={issueStatusSearchOptions}>{children}</SavedViewIssueStatusContext>
}

export function useSavedViewIssueStatusSearchOptions(): IssueStatusSearchOptions | undefined {
  return use(SavedViewIssueStatusContext)
}
